<script>

export default {
  data () {
    return {
      conf: {},
      ready: false
    }
  },
  created () {
    this.fetchBrand();
  },
  methods: {
    getPlatform () {
      const url = new URL(window.location.href);
      const s = url.searchParams.get('platform');
      const platform = s == null ? -1 : Number(s);
      return {
        platform
      };
    },
    async fetchBrand () {
      const {platform} = this.getPlatform();
      const {data: resp} = await this.$http.get('/api/v1/brand', {
        params: {
          platform: platform > -1 ? platform : void 0
        }
      })
      this.ready = true;
      if (resp.code === 200) {
        document.title = `${resp.data.title}-动画工具`;
        if (resp.data.configure) {
          this.conf = JSON.parse(resp.data.configure);
        }
      } else {
        document.title = `来画动画-工具`;
      }
    },
    openPage () {
      const a = document.createElement('a');
      a.href = '/workplace/dashboard/creator/all';
      a.click();
      a.remove();
    }
  }
}
</script>

<template>
  <div class="app-logo-wrapper" @click="openPage">
    <div
      v-if="conf.newToolLogo"
      class="app-logo custom"
      :style="{
        content: `url(${$handleAssetsUrl(conf.newToolLogo)})`
      }"
    ></div>
    <div
      v-else-if="ready"
      class="app-logo official"
    >

    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-logo {
  width: 68px;
  height: 30px;
  margin-left: 13px;
  cursor: pointer;
  object-fit: contain;
  content: url(../../../static/svg/laipic-logo-dark.png)
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/appLogo.vue